import React from 'react'
import * as R from 'remeda'

import { type Question } from '~/hooks/useSurveyQuery'
import { getDiffKey } from '~/utils'

import { useAtomValueContext } from '../providers/AtomsProvider'
import { type QuestionsDiff, type QuestionsDiffColumnKey } from '../utils'

export const useMapQuestionsDiff = (question: Question) => {
  const questionsDiffsMap = useAtomValueContext('questionsDiffsMap')

  return React.useCallback(
    <T>(
      mapFunc: (questionsDiff: QuestionsDiff, index: number) => T,
    ): Record<QuestionsDiffColumnKey, T> =>
      R.mapToObj(
        questionsDiffsMap[question.question_id] ?? [],
        (questionsDiff, index) => [
          getDiffKey(questionsDiff),
          mapFunc(questionsDiff, index),
        ],
      ),
    [question.question_id, questionsDiffsMap],
  )
}
